/*
 * Copyright 2020 Thomer Gil [https://thomer.com/games/brickbreaker-js/]
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
// {{{ import
import * as ex from 'excalibur';
import { Game } from './game';
// }}}

// https://groups.google.com/forum/#!topic/excaliburjs/wJSf2CpTMKo
export class PauseScene extends ex.Scene {
    // {{{ members, constructors
    public bgSceneToRender: ex.Scene;

    constructor() {
        super();
    }
    // }}}

    private _unpauseKeyPressed = false;

    private _keyListenerAdded = false;

    onInitialize() {
        this._addKeyListener();
    }

    onActivate() {
        this._addKeyListener();
    }

    private _addKeyListener() {
        if (this._keyListenerAdded) return;
        this._keyListenerAdded = true;
        // Use native event listener to detect mapped key (not physical key)
        // This respects keyboard layouts like Dvorak
        window.addEventListener('keydown', (e) => {
            // Only handle if this scene is currently active
            if (!this.isCurrentScene()) return;
            if (e.key.toLowerCase() === 'p' && !e.repeat) {
                this._unpauseKeyPressed = true;
            }
        });
    }

    // {{{ public
    public update(game: Game, delta: number): void {
        super.update(game, delta);
        if (this._unpauseKeyPressed) {
            this._unpauseKeyPressed = false;
            this.unpause();
        }
    }

    public onPreDraw(ctx, delta): void {
        this.bgSceneToRender.draw(ctx, delta);
    }

    public unpause(): void {
        Game.Instance().play();
    }
    // }}}
}
